<template>
	<div class="dashboard">
		<!--PDF EXPORTING-->
		<radial-graph
			style="position:fixed; top: -1000px; left:-1000px; width: 680px; height: 680px"
			:graph_data="audit_data.scores"
			subtitle_1="This audit"
			:subtitle_2="'Average score for \'' + audit.venue.name + '\''"
			:disable_duration="true"
			@update_graph_image="updatedGraphImage"
		></radial-graph>

		<div class="bg-white container-fluid p-0 pt-3">
			<div class="container">
				<!--Header-->
				<div class="row m-auto justify-content-center p-2">
					<div class="w-100 d-md-flex justify-content-between">
						<div class="p-0 col-12 col-md-6 text-light text-center text-md-left mb-4 mb-md-0 d-flex justify-content-between">
							<div class="no-gutters">
								<h3 class="w-100">{{audit.venue.name}}</h3>
								<h5 class="text-pink w-100">Audited by {{audit.user.first_name + ' ' + audit.user.last_name}} on {{audit.formatted_date}}</h5>
							</div>
							<div>
								<button v-if="showVenueSelection == false"
									class="btn btn-primary d-inline-flex"
									v-on:click="changeAssignedVenue"
									>Change Venue <div v-if="downloading_pdf" class="loaders--button"></div>
								</button>
								<custom_select
									v-if="showVenueSelection == true"
									empty_message="No venues found"
									name="selected_venue"
									no_selection_name="-- Select a venue --"
									:fixed="true"
									:prepend_selection="{label: 'All Venues', value: 'all'}"
									:options="venues"
									:pre_selected="audit.venue.value"
									@selected="selectedEvent"
									ref="venue_select"
								></custom_select>
							</div>
						</div>
						<div>
							<div class="col-7 my-auto text-center text-md-right">
								<div class="text-pink d-inline-flex">
									<i class="my-auto" v-if="audit.improved === true"><img src="@/images/up.svg" width="30" height="18" /></i>
									<i class="my-auto" v-else-if="audit.improved === false"><img src="@/images/down.svg" width="30" height="18" /></i>
									<i class="my-auto" v-else> - </i>
									<h1
										class="font-weight-bold ml-3"
										v-bind:class="audit_score_class"
										style="font-size: 4em;"
									>{{audit_data.audit_scores.total + '/' + audit_data.audit_scores.max}}</h1>
								</div>
							</div>
						</div>
				</div>
					
				</div>

				<div class="row m-auto justify-content-center p-2">
					<div class="col-12 text-center">
						<button
							class="btn btn-primary d-inline-flex"
							v-on:click="downloadPdf"
							v-bind:disabled="radial_graph_image == null || downloading_pdf"
						>Download PDF <div v-if="downloading_pdf" class="loaders--button"></div></button>
					</div>
				</div>

				<!--Card Content-->
				<div class="row py-5">
					<div class="col-12">
						<stats-scores
							:venue="audit.venue"
							:venue_data="audit_data"
							last_label="Previous"
							radial_subtitle_1="This audit"
							:radial_subtitle_2="'Average score for \'' + audit.venue.name + '\''"
						></stats-scores>
					</div>
				</div>
			</div>
		</div>

		<!--Rest of the container-->
		<div class="container mt-5">
			<div class="row m-auto justify-content-center p-2">
				<div class="col-12 col-lg-8 container">
					<div class="row">
						<div class="col text-left text-md-left mb-4 mb-md-0">
							<h3 class="font-weight-bold ">Questions</h3>
						</div>
					</div>
					<div class="row mt-1">
						<div class="col-12 col-md-6">
							<comments-card
								:comments="audit_data.bad_comments"
								type="bad"
							></comments-card>
						</div>
						<div class="col-12 col-md-6">
							<comments-card
								:comments="audit_data.good_comments"
								type="good"
							></comments-card>
						</div>
					</div>
					<!--question group-->
					<div v-for="(group, group_name) in audit_data.audit_scores.groups" class="row mt-1">
						<div class="col-12 audit-card mx-0 container">
							<div class="d-flex">
								<h5 class="ml-0 text-primary font-weight-bold mr-auto">{{group_name}}</h5>
								<h5 class="mr-0 text-primary font-weight-bold ml-auto">{{group.total + '/' + group.max}}</h5>
							</div>
							<hr/>
							<div class="question-score" v-for="(question, question_name) in group.questions">
								<div class="d-flex">
									<div class="ml-0 mr-auto my-auto">
										<h5 class="text-light">{{question_name}}</h5>
										<small v-if="question.text">
											<em><q>{{question.text}}</q></em>
										</small>
									</div>
									<div class="mr-0 ml-auto float-right">
										<h4 class="text-primary font-weight-bold">{{question.score +'/'+ question.max}}</h4>
									</div>
								</div>
								<hr/>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-4 pl-lg-5 text-left container">
					<div class="row">
						<div class="col-12 p-0"><h3 class="font-weight-bold ">Information</h3></div>
					</div>
					<div class="row">
						<!--Loyalty card-->
						<div class="col-12 bg-white audit-card mx-0">
							<div class="w-100 d-inline-flex">
								<h6 class="ml-0 mr-auto py-1">Loyalty Cards</h6>
								<h6 class="mr-0 ml-auto py-1 text-primary font-weight-bold">
									{{audit.loyalty_card ? 'Yes' : 'No'}}
								</h6>
							</div>
							<div class="w-100">
								<small v-if="audit.loyalty_card && audit.loyalty_card_text">{{audit.loyalty_card_text}}</small>
							</div>
						</div>

						<!--Photos-->
						<div v-for="photo in photos" class="col-12 col-md-6 col-lg-12 p-0">
							<div class="container">
								<div class="row p-0 p-md-2 p-lg-0">
									<div class="audit-card mx-0 p-0">
										<img onmousemove="return false" onmousedown="return false" class="img-fluid m-0 p-0" :src="photo.url" @error="imageNotFound(photo)">
										<div class="w-100 p-3">
											<div class="w-100"><span>{{photo.comment}}</span></div>
											<div class="w-100"><span>{{photo.created_at}}</span></div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="col-12 col-md-6 col-lg-12 p-0" v-if="hasVenueLocation()">
							<div class="container">
								<div class="row p-0 p-md-2 p-lg-0">
									<div class="audit-card mx-0 p-0">
										<img
											onmousemove="return false"
											onmousedown="return false"
											class="img-fluid m-0 p-0"
											:src="getMap()"
											@error="imageNotFound(photo)"
										>
										<div class="w-100 p-3">
											<span>{{audit.venue.lat + ', ' + audit.venue.long}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!--Signature-->
						<div class="col-12 bg-white audit-card mx-0">
							<img onmousemove="return false" onmousedown="return false" :src="audit.signature_url" alt="" class="img-fluid">
							<div class="my-2 text-light">
								<span>Signature</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import StatsAndScoresComponent from './graphs/StatsAndScoresComponent.vue'
	import RadialGraphComponent from './graphs/RadialGraphComponent.vue';
	import AuditCardComponent from './content/AuditCardComponent.vue'
	import CommentsCardComponent from './content/CommentsCardComponent.vue'
	import CustomSelectComponent from '../general_components/CustomSelectComponent.vue';


	export default {
		components:{
			'stats-scores': StatsAndScoresComponent,
			'audit-card': AuditCardComponent,
			'radial-graph': RadialGraphComponent,
			'comments-card': CommentsCardComponent,
			'custom_select': CustomSelectComponent
		},

		props:[
			'change_assigned_venue_url',
			'audit',
			'audit_data',
			'google_maps_api_key',
			'pdf_export_url',
			'venues',
			'update_url',
			'redirect_url',
			'photo_placeholder_url',
		],

		data(){
			return {
				photos: [],
				venueList: [],
				downloading_pdf: false,
				radial_graph_image: null,
				isModalOpen: false,
				showVenueSelection:false,
				update_venue:{}
			}
		},

		mounted() {
			this.photos = this.audit.photos;
		},

		methods: {
			selectedEvent(e){
				this.updated_venue = e
				this.assignToVenue()
            },
			assignToVenue(){
			let _this = this;
			axios.put(_this.update_url, {
                    venue: this.updated_venue,
                })
				.then(response => {
					window.location.href = this.redirect_url
                	console.log('success');
                })
                .catch(error => {
                    console.log('no success')
                });
	
			},
			changeAssignedVenue(){
				this.showVenueSelection = true
				// window.location.href = this.change_assigned_venue_url
			},

			imageNotFound(photo){
				//Image was not found or deleted, let's replace with the placeholder
				photo.url = this.photo_placeholder_url
			},

			hasVenueLocation(){
				return this.audit.venue != null && this.audit.venue.lat != null && this.audit.venue.long != null;
			},

			getMap(){
				if (!this.hasVenueLocation()) {
					return '';
				}
				let location = this.audit.venue.lat + ',' + this.audit.venue.long;
				return 'https://maps.googleapis.com/maps/api/staticmap?center=' + location +
				'&zoom=17&size=600x400&markers=color:blue%7C' + location +
				'&key=' + this.google_maps_api_key
			},

			updatedGraphImage(data) {
				this.radial_graph_image = data;
			},

			downloadPdf(){
				let _this = this;


				if (_this.downloading_pdf || _this.radial_graph_image == null){
					return;
				}

				_this.downloading_pdf = true;

				axios({
					url: _this.pdf_export_url,
					method: 'post',
					data: {
						audit: _this.audit,
						audit_data: _this.audit_data,
						map_url: _this.getMap(),
						graph_data: _this.radial_graph_image
					},
					responseType: 'blob'
				})
					.then(function (response){
						let
							link = document.createElement('a');

						link.href = window.URL.createObjectURL(new Blob([response.data]));
						link.setAttribute('download', _this.audit.created_at + ' Audit Report.pdf');
						document.body.appendChild(link);
						link.click();

						_this.downloading_pdf = false;
					});
			}
		},
		computed: {
			audit_score_class() {
				if (this.audit_data.audit_scores.total < 70) {
					return 'text-pale-yellow';
				}
				else if (this.audit_data.audit_scores.total < 80) {
					return 'text-yellow';
				}
				else {
					return '';
				}
			}
		}
	}
</script>
